import { render } from "./TemplatesDownload.vue?vue&type=template&id=18ca36df&scoped=true&ts=true"
import script from "./TemplatesDownload.vue?vue&type=script&lang=ts"
export * from "./TemplatesDownload.vue?vue&type=script&lang=ts"

import "./TemplatesDownload.vue?vue&type=style&index=0&id=18ca36df&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ca36df"]])

export default __exports__